<angular-loader></angular-loader>
<notification #notification></notification>
<div>
  <app-header-pibank #header [isAuthenticated]="isLogged"></app-header-pibank>
  <div class="main-container">
    <router-outlet></router-outlet>
  </div>
</div>
<app-footer></app-footer>
<app-modal></app-modal>
